export const DEFAULT_HEATMAP_CELL_PADDING = 1
export const DEFAULT_INNER_CELL_PADDING = 3
export const CELL_NULL_COLOR = "#EBEDF0"


// WEBPACK FOOTER //
// ./src/components/visualizations/heatmap/default-design.ts